import { render, staticRenderFns } from "./Bewirtschaftung.vue?vue&type=template&id=c57f3a14"
import script from "./Bewirtschaftung.vue?vue&type=script&lang=js"
export * from "./Bewirtschaftung.vue?vue&type=script&lang=js"
import style0 from "./Bewirtschaftung.vue?vue&type=style&index=0&id=c57f3a14&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c57f3a14')) {
      api.createRecord('c57f3a14', component.options)
    } else {
      api.reload('c57f3a14', component.options)
    }
    module.hot.accept("./Bewirtschaftung.vue?vue&type=template&id=c57f3a14", function () {
      api.rerender('c57f3a14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Bewirtschaftung.vue"
export default component.exports